const binding = { modules: {}, dataActions: {} };

    (binding.modules['proof-points'] = {
        c: () => require('partner/modules/proof-points/proof-points.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'proof-points',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/proof-points'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|proof-points|proof-points'] = {
                c: () => require('partner/modules/proof-points/proof-points.view.tsx'),
                cn: '__local__-__local__-proof-points'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };